import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete, TextField } from '@mui/material';
import { useState } from 'react';
let debounce;
const apiHost = process.env.REACT_APP_API_HOST || process.env.NEXT_PUBLIC_API_HOST;
const SingleGeographyAutocomplete = ({ geo, onChange, }) => {
    const [options, setOptions] = useState([]);
    const [loading, setIsLoading] = useState(false);
    const fetchResults = (searchTerm) => {
        if (searchTerm.length < 3)
            return;
        setIsLoading(true);
        fetch(apiHost + '/gapi/suggestions?name=' + searchTerm)
            .then((response) => response.json())
            .then((responseJson) => {
            const results = responseJson.map((value) => {
                setIsLoading(false);
                return value;
            });
            setOptions(results);
        })
            .catch((error) => {
            setIsLoading(false);
            console.log(error);
        });
    };
    const onInputChange = (e, value, reason) => {
        if (reason === 'clear')
            return;
        if (debounce)
            clearTimeout(debounce);
        debounce = setTimeout(() => fetchResults(value), 500);
    };
    return (_jsx(Autocomplete, { options: options, onInputChange: onInputChange, sx: { width: '300px' }, value: geo, isOptionEqualToValue: (value, option) => value.place_id === option.place_id, getOptionLabel: (option) => {
            if (typeof option === 'object') {
                return (option === null || option === void 0 ? void 0 : option.description) || (option === null || option === void 0 ? void 0 : option.formatted_address) || '';
            }
            return '';
        }, onChange: (e, newValue) => onChange(newValue), noOptionsText: loading ? 'Loading...' : 'Type to search', renderInput: (params) => (_jsx(TextField, Object.assign({}, params, { variant: "outlined", placeholder: "Type to Search" }))) }));
};
export default SingleGeographyAutocomplete;
